export default __webpack_public_path__ + "static/media/icon_chevron_right.f4a703fa.svg";